// Example: CustomersPage.js
import React from 'react';
import Customers from '../components/Customers';

const CustomersPage = () => (
    <Customers />
);

export default CustomersPage;